export const formatCurrency = (amount: number, currency: string): string => {
  const formattedAmount = amount.toLocaleString('en-US', {
    minimumFractionDigits: 2,
    maximumFractionDigits: 2,
  });
  if (currency === 'USD') {
    return `$${formattedAmount}`;
  }
  return `${currency} ${formattedAmount}`;
};
